// extracted by css-extract-rspack-plugin
export default {"answer":"_f2bb0ef3"};